// eslint disable-next-line
import qs from 'qs';

export default function normalizeFormData (target) {
    // get the from data
    const formData = new FormData(target);

    // normalize the form data
    const data = [];

    for (const item of formData)
    {
        const key = item[0];
        const value = item[1];

        if (typeof data[key] !== 'undefined')
        {
            const foo = data[key];

            data[key] = [];
            data[key].push(value, foo);
        }
        else
        {
            data[key] = value;
        }
    }

    console.log(data);

    return qs.stringify(data);
}
